<template>
    <div
        class="items-wrapper cursor-pointer pr-2"
        :class="{
            draggable: !flags?.readonly,
            selected: isSelected || isActiveEps,
            active: isActive,
            'print-area': isPrintArea,
            'product-guidelines': isProductGuidelines,
            overlay: isOverlay
        }"
        :style="itemStyle"
        :data-zIndex="item.zIndex"
        @click="onElementClick"
    >
        <slot />
    </div>
</template>

<script lang="ts" setup>
import type { ListElements } from '@/typings/customilyElements/layer';
import { useLayerTreeItem } from '@/components/Layers/composables/useLayerTreeItem';

const props = defineProps<{
    item: ListElements;
}>();

const {
    flags,
    isSelected,
    isActiveEps,
    isActive,
    itemStyle,
    isPrintArea,
    isProductGuidelines,
    isOverlay,
    onElementClick
} = useLayerTreeItem(props);
</script>

<style lang="scss" scoped>
@import 'node_modules/bootstrap/scss/bootstrap.scss';

$icon-size: 20px;
$icon-font-size: 14px;

.items-wrapper {
    border: none;
    padding: 0;
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;

    &.active:not(.selected) {
        background-color: #dbe6f0 !important;
    }
    &.selected {
        color: white;
        fill: white;

        &:not(.print-area) {
            background: #87acd5;
        }

        &.print-area {
            background: repeating-linear-gradient(45deg, #87acd5, #87acd5 10px, #7b9cc0 10px, #7b9cc0 20px);
        }
    }
    &.print-area {
        background: repeating-linear-gradient(45deg, transparent, transparent 10px, #7157e020 10px, #7157e020 20px);
    }

    &.product-guidelines {
        background: #ede9fb;
    }

    &.overlay {
        box-shadow: inset 0px 7px 12px -10px #7157e0, inset 0px -7px 12px -10px #7157e0;
    }
    .action {
        text-align: center;
        width: 1.3rem;
    }
    .layer-row {
        display: flex;
        align-items: center;
        width: 100%;
    }

    .layers-element-title.not-visible {
        opacity: 0.5;
    }
    .draggable {
        cursor: pointer;
    }
}

::v-deep .layers-element-title {
    .editable-div {
        display: flex;
        align-items: center;
        span:first-child {
            padding-right: 4px;
        }
        .rename-btn {
            font-size: 10px;
        }
    }
}

.items-wrapper {
    &.selected {
        .action-icon,
        .action-icon-selected {
            fill: #fff;
        }

        .element-icon {
            color: white;
            fill: white !important;
        }

        .open-close-icon {
            fill: white;
        }
        .status-icon,
        .action-icon {
            color: #fff;
        }
    }
    .layers-element-title .editable-input {
        background: #f2f2f2;
        width: 100%;
        border: none;
        color: black;
    }
    .element-icon {
        align-self: center;
        color: var(--primary-blue);
        fill: var(--primary-blue);
    }
    .icon {
        width: $icon-size;
        height: $icon-size;
        float: left;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: $icon-font-size;
    }
    .open-close-icon {
        fill: #a7aab4;
    }
}
</style>
